<p-tabView [(activeIndex)]="index" (onChange)="getIndex($event)">
    <p-tabPanel header="{{'Configuration.CRM.Channel' | transloco}}">
        <app-crm-shared-channel 
            [moduleId]="moduleId" 
            [addNewElement]="addNewElement" 
            (cancelChannelAddUpdateModal)="cancelChannelAddUpdateModal()"></app-crm-shared-channel>
    </p-tabPanel>
  
    <p-tabPanel header="{{'Configuration.CRM.Template' | transloco}}">
        <app-crm-shared-template *ngIf="index === 1" [moduleId]="moduleId"></app-crm-shared-template>
    </p-tabPanel>
  
    <p-tabPanel header="{{'Configuration.CRM.Fields' | transloco}}">
        <app-account-fields  *ngIf="index === 2" [addNewField]="addNewField" [accountFieldConfig]="accountFieldConfig"
          (reLoadConfigurations)="reLoadConfigurations($event)">
        </app-account-fields>
    </p-tabPanel>
  
    <!-- <p-tabPanel header="{{'Configuration.CRM.Setting' | transloco}}">
      <app-setting></app-setting>
    </p-tabPanel> -->
  
    <p-tabPanel [disabled]="true" headerStyleClass="iconPanel" appendTo="body">
        <ng-template pTemplate="header">
            <p-menu #configmenuInventory id="config_menu_inventory" [model]="configMenuCaseItems" [popup]="true" appendTo="body">
            </p-menu>
            <span class="btnBars p-mr-0" (click)="configmenuInventory.toggle($event)">
                <i class="pi pi-bars"></i>
            </span>
        </ng-template>
    </p-tabPanel>
  </p-tabView>
  